<template>
    <div class="topic" >
      <div v-wechat-title="$route.meta.title=docTitle"></div>
      <div class="topic-top">
        <div class="topic-top-content">
          <div class="bottom"  :style="{'background-image':'url('+ topic.logoUrl || 'https://img.zhanshangxiu.com/showonline/file/202009/976f30b982904045aeec14be2bb0dea2.png' +')'}" >
          </div>
          <div class="center"></div>
          <div class="top" >
            <img v-if="topic.logoUrl" :src="topic.logoUrl"  v-load="'oPic'">  
            <img v-else src="https://img.zhanshangxiu.com/showonline/file/202009/976f30b982904045aeec14be2bb0dea2.png" >
            <div  class="topic-top-title">
              <p>
              #{{topic.title}}#
              </p>
              <div class="topic-top-read">
                <span>
                  阅读数：{{$service.getCount(topic.viewCount)}}
                </span>

                <span>
                  讨论数：{{$service.getCount(topic.talkCount)}}
                </span>
              </div>
              <div  class="topic-top-man">
                <span v-if="topic.publisherType!=1"> 发起人：{{topic.publisherName}}  </span>
                <span v-else> 发起人：官方  </span>
              </div>
              <div class="guanzhu" v-if="!topic.isFollow" @click.stop="likeClick(topic.id)">
                <span>关注</span>
              </div>
              <div class="guanzhu-s" v-else @click.stop="cancelLike(topic.id)">
                <span>已关注</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="topic-Introduction">
        <p>
          导语：{{topic.summary}}
        </p>
      </div>
      <div style="padding-bottom:1.1rem">
        <div style="width: 100%;height: 100%;background-color: transparent" v-if="inputShowed"></div>
        <div class="topic-detail-top" v-for="(item,index)  in dataList" :key="index" @click="goTopicdetail(item.id)">
          <div class="topic-detail-top-box">
            <div class="topic-detail-top-avatarUrl">
              <img :src="item.member.avatarUrl"  class="avatarUrl" v-load="'oPicXS'"  v-if="item.member.avatarUrl" >
              <img src="@/assets/img/empty.png"  class="avatarUrl" v-else >
              <div>
                 <span class="span1">
                   {{item.member.name || item.member.nickName}}
                    <span style="color: #666;font-size:0.2rem;padding-left:0.12rem;line-height:0.26rem;font-weight: normal;">
                     {{item.member.jobTitle }}
                   </span>
                 </span>
                <span  class="span2">
                   {{item.member.company}}
                 </span>
              </div>
            </div>
            <p>
              {{item.content}}
            </p>
            <div class="topic-detail-top-img" v-if="item.imgUrls">
              <template  v-for="(imgList, index2) in item.imgUrls.split(';')">
                <img :src="imgList" v-load="'oPic'"  :key="index2" v-if="imgList" />
              </template>
            </div>

            <div class="topic-detail-top-tips">
              <span v-for="(themes,index3) in item.themes" :key="index3">
                #{{themes.title}}#
              </span>

            </div>
            <div class="topic-detail-top-read">
              <span class="number">{{item.viewCount}}</span>
              <span class="text">
              浏览
            </span>
              <span class="number">{{item.commentCount}}</span>
              <span class="text">
              评论
            </span>
              <span class="number">{{item.likeCount}}</span>
              <span class="text">
             点赞
            </span>
              <span class="time">
              {{item.createAt}}
            </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 输入框 -->
      <div class="topic-detail-bottom">
        <div class="topic-detail-bottom-input">
          <span @click="goToHotPub()">说说您的看法吧~</span>
        </div>
        <div class="topic-detail-bottom-share" @click="$refs.shareModel.open()">
          <i class="icon iconfont icon-fenxiang2 fenxiang"></i>
          <span>分享</span>
        </div>
      </div>
      
      <shareModel ref="shareModel"></shareModel>

    </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from "vuex";
  import shareModel from "@/components/shareModel";
  import gql from 'graphql-tag';
  export default {
    data() {
      return {
        topic:'',
        inputShowed:false,

        loading: false, //展商加载状态
        finished: false, //加载是否完成状态
        dataList: [], //供需列表
        pageSize: 10,
        pageIndex: 1,
        totalCount: 0,
        totalPages: 0,
        docTitle:'话题详情',
      };
    },
    components: {
        shareModel
    },

    computed: {
      ...mapGetters({
        exhibitionId: "getExhibitionId",
        userInfo: "getUserInfo",
      }),
      topicId() {
        return this.$route.query.topicId;
      },
      ThemeGql(){
          return gql `query
                  theme($id: Guid!){
                      theme(id: $id){
                          content
                          createAt
                          exhibitionId
                          followCount
                          id
                          isDeleted
                          isFollow(memberId:"${this.userInfo.id}")
                          logoUrl
                          memberId
                          publisherName
                          publisherType
                          shareCount
                          summary
                          talkCount
                          title
                          userCount
                          viewCount
                      }
                  }`
      },
      TalksListGql(){
          return gql `query
                  getTalks($themeId: Guid!,$page: Int!,$size: Int! ){
                      getTalks(themeId:$themeId,page:$page,size:$size){
                          hasNextPage
                          hasPreviousPage
                          items{
                              commentCount
                              content
                              createAt
                              id
                              imgUrls
                              isLike(memberId:"${this.userInfo.id}")
                              likeCount
                              member{
                                avatarUrl
                                businessCard
                                company
                                department
                                id
                                jobTitle
                                name
                                nickName
                                phone
                              }
                              memberId
                              orgin
                              shareCount
                              themes{
                                content
                                createAt
                                followCount
                                id
                                logoUrl
                                shareCount
                                summary
                                talkCount
                                title
                                userCount
                                viewCount
                              }
                              userCount
                              viewCount
                          }
                          pageIndex
                          pageSize
                          totalCount
                          totalPages
                      }
                  }`
      },

    },
    created() {
      this.init()
    },
    methods: {
      ...mapActions({
        goTopicdetail:'linkTo/LinkToHotTopDetails',
        TopicView:'topicSupply/TopicView', // 增加浏览数
        followerTopic:'follower/followerTopic', // 关注
        delFollowerTopic:'follower/delFollowerTopic', // 取消关注
        LinkHotPub:'linkTo/LinkHotPub',
        shareToWechat:'wxShare/shareToWechat',
        LinkToError:'linkTo/LinkToError',
        getSettingShare:'wxShare/getSettingShare', //分享配置展会
        generateShareTemplate:'wxShare/generateShareTemplate', //关键字替换
      }),
      async init(){
        await this.$Myapollo.getUserInfo(this);
        //增加浏览
        let user={
          avatarUrl:this.userInfo.avatarUrl,
          name:this.userInfo.name,
          company:this.userInfo.company
        }
        let opt3={
          themeId:this.topicId,
          memberId:this.userInfo.id,
          userInfo:JSON.stringify(user),
          number:1
        }
        await this.TopicView(opt3)
        this.getTheme();
        this.getTalkList();
      },
      getTheme(){
        this.$apollo.addSmartQuery("theme",{
            query:this.ThemeGql,
            variables:{
                id:this.topicId
            },
            fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
            result(res){
                let data = JSON.parse(JSON.stringify(res));
                if(data&&data.data.theme){
                  this.topic = data.data.theme;
                  this.docTitle = this.topic.title;
                  // // 分享的配置
                  // const opt = {
                  //     title:`给您推荐了一个话题`,
                  //     desc: `#${this.docTitle}#`,
                  //     link: window.location.href,
                  //     imgUrl:this.topic.logoUrl
                  // };
                  // this.shareToWechat(opt);
                  this.$store.commit("setExhibitionId",this.topic.exhibitionId);
                  this.getShareVal();
                } else {
                  this.LinkToError();
                }
            },
            error(error) {
                console.error(error,'error错误处理')
            }
        })
      },
      // 获取自定义分享
      async getShareVal() {
        let res = await this.getSettingShare({id:this.exhibitionId,name:'share.theme.config'});
        if(res){
          let shareMsg = JSON.parse(res);
          let objTemp = {
              talk:this.topic.title || '',
              remarks:this.topic.summary || '',
          };
          let  opt = {
            temp:shareMsg.content,objTemp:objTemp
          }
          let  optdes = {
            temp:shareMsg.des,objTemp:objTemp
          }
          let msg = await this.generateShareTemplate(opt);
          let des = await this.generateShareTemplate(optdes);
          shareMsg.content = msg;
          shareMsg.des = des;
          this.shareV = shareMsg;
        }
        // 活动的分享配置
        const req = {
          title:this.shareV.content ||  `给您推荐了一个话题`,
          desc: this.shareV.des || `#${this.docTitle}#` || this.topic.summary || '',
          link: window.location.href,
          imgUrl:this.topic.logoUrl
        };
        this.shareToWechat(req);
      },
      getTalkList(){
        this.$apollo.addSmartQuery("getTalks",{
            query:this.TalksListGql,
            variables:{
                themeId:this.topicId,
                page: this.pageIndex,
                size: this.pageSize,
            },
            fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
            result(res){
                let data = JSON.parse(JSON.stringify(res));
                if(data&&data.data.getTalks.items.length){
                    let currentList = data.data.getTalks.items;
                    if(this.pageIndex == 1){
                        this.dataList = currentList;
                    } else {
                        this.dataList = [...this.dataList,...currentList]
                    }
                    this.loading = false;
                    if (!data.data.getTalks.hasNextPage) {
                        this.finished = true;
                    }
                }
            },
            error(error) {
                console.error(error,'error错误处理')
            }
        })
      },

      // 分享
      onShareAppMessage(options) {
        let thas = this;
        if (options.from === 'button') {
          shareObj = {
            desc: "向您推荐了一个优质话题",
            imageUrl: '/images/img_honorbook_masterdata.png',
            success: function (res) {
            }
          }
          return shareObj;
        }
      },
      async share(){
        if(this.userInfo.phone&&this.userInfo.name&&this.userInfo.company){
          // wx.setNavigationBarTitle({
          //   title: "向您推荐一个优质话题"
          // })
          let opt={
            themeId:this.topicId,
            memberId:this.userInfo.id
          }
          let data=await this.TopicShare(opt)
          console.log(data,'data')
        }
        else{
          this.unAuth()
        }
      },
      //关注
      async likeClick(id){
        let user={
          name:this.userInfo.name,
          nickName:this.userInfo.nickName,
          avatarUrl:this.userInfo.avatarUrl,
          jobTitle:this.userInfo.jobTitle
        }
        let opt={
          themeId:id,
          memberId:this.userInfo.id,
          userInfo:JSON.stringify(user)
        };
        let res= await this.followerTopic(opt);
        if(res.result){
          this.$toast.success('已关注 ');
          this.topic.isFollow=true
        }else{
          this.$toast.fail("关注失败");
        }
      },
      //取消关注
      async cancelLike(id){
        let opt={
          themeId:id,
          memberId:this.userInfo.id
        }
        let res=await this.delFollowerTopic(opt);
        if(res.result){
          this.$toast.success('取消关注 ');
          this.topic.isFollow=false
        }else{
          this.$toast.fail('取消失败');
        }
      },
      //去发布话题
      goToHotPub(){
        if (!this.userInfo.phone) { this.$Myapollo.unverifiedDialog(this); return; }  
        localStorage.removeItem('content');
        localStorage.removeItem('relepase');
        localStorage.removeItem('Upimg');
        this.LinkHotPub({id:this.topicId})
      },
    }
};
</script>

<style scoped lang='scss'>
.topic{
    min-height: 100vh;
    background: #f5f5f5;
}
  .topic-top{
    background-color: #1d2435;
    height:2.1rem;
    width:100%;
    &-title{
      p{
        color: #fff;
        overflow: hidden; //独立一行 超过部分隐藏
        text-overflow: ellipsis; //省略号
        white-space: nowrap;
        font-size: .3rem;
        font-weight:bold;
        max-width: 5.4rem;
      }
    }
    &-read{
      span{
        color: #fff;
        font-size: .22rem;
        display: inline-block;
        margin:.25rem .4rem .15rem 0;
      }
    }
    &-man{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
            color: #fff;
            display: inline-block;
            font-size: .22rem;
            font-weight: 600;
        }
    }
    &-content{
      padding: .3rem .24rem;
      position: relative;
      height: 100%;
      .bottom{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: 100%;
        background-position: center;
        filter: blur(1px);
      }
      .center{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 6;
        background: rgba(0, 0, 0, 0.5);
      }
      .top{
        position: absolute;
        padding: .3rem .24rem;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        display: flex;
      }
      img{
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 3px;
        margin-right:.2rem;
        // background-color:#fff
      }
    }
  }
  .topic-Introduction{
    background-color: #fff;
    margin-top: .2rem;
    p{
      padding:.28rem .24rem;
      font-size: .3rem;
      font-weight: normal;
      line-height: .48rem;
      color: #333;
    }
  }
  .guanzhu{
    width: 1.1rem;
    height: .48rem;
    background-color: #f85b0f;
    border-radius: .24rem;
    position: absolute;
    bottom: .3rem;
    right: .24rem;
    text-align: center;
    span{
        color: #fff;
        line-height: .48rem;
        font-size:.24rem
    }
  }
  .guanzhu-s{
    width: 1.1rem;
    height: .48rem;
    background-color: transparent;
    border: 1px solid #f85b0f;
    border-radius: .24rem;
    position: absolute;
    bottom: .3rem;
    right: .24rem;
    text-align: center;
    span{
        color: #f85b0f;
        line-height: .48rem;
        font-size:.24rem
    }
  }
  .topic-detail-top{
      margin: .3rem .24rem;
      box-shadow: 0px 0px 5px 0px
      rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      margin-bottom: .3rem;
      background-color: #fff;
      &-box{
        padding:.3rem .2rem;
      }
      &-avatarUrl{
        display:flex;
        width:100%;
        align-items: center;
      }
    p{
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: .22rem;
    }
      &-img{
        display: flex;
        margin-top: .22rem;
        img{
          width:1.1rem;
          height:1.1rem;
          margin-right:.1rem;
          background:#333333;
        }
      }
      &-tips{
        margin: 0.2rem -0.1rem -0.1rem 0;
        span{
          padding:.06rem .18rem;
          font-size: .22rem;
          color: #ff5500;
          background-color: #ffddcc;
          border-radius: .16rem;
          margin-right:.1rem;
          margin-bottom: 0.1rem;
          display: inline-block;
        }
      }
      &-read{
        margin-top: .3rem;
        position: relative;
        display: flex;
        align-items: center;
        .number{
          margin-right: 3px;
          display: inline-block;
          font-size: .22rem;
          color: #666;
        }
        .text{
          margin-right: .3rem;
          display: inline-block;
          font-size: .22rem;
          color: #666;
        }
        .time{
          font-size: .22rem;
          color: #666;
          position: absolute;
          right: 0;
        }
      }
  }
  .avatarUrl{
    width: .7rem;
    height: .7rem;
    border-radius: 50%;
    background-color: #1d2435;
    margin-right: .16rem;
  }
  .span1{
    font-size: .26rem;
    font-weight: bold;
    color: #333;
    display: block;
  }
  .span2{
    font-size: .22rem;
    color: #666;
    display: block;
    margin-top: .05rem;
  }
  .topic-detail-bottom{
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 1rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0px 3px 0px
    rgba(0, 0, 0, 0.2);
    &-input{
      margin:.17rem .24rem;
      width:6rem;
      height: .64rem;
      background-color: #f2f2f2;
      border-radius: .32rem;
      position: relative;
      display:flex;
      align-items: center;
      span{
        margin-left:.26rem;
        width: 5.5rem;
        color:#999
      }
    }
    &-share{
        text-align:center;
        margin:.2rem 0 .17rem .22rem;
        span{
            display: block;
            color:#666;
            font-size:.22rem
        }
    }
  }
  .fenxiang{
    display: inline-block;
    font-size:.34rem;
    transform: scale(2);
    margin-bottom:.08rem
  }
  button{
    padding: 0;
    line-height: 1;
    background-color: #fff;
  }
  button:after{
    border: none;
  }
</style>

